import React from 'react';
import Layout from '@/components/layout/Layout';
import { useLanguage } from '@/context/language-context';

const Cookies = () => {
  const { t } = useLanguage();
  const currentDate = new Date();
  const formattedDate = `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;
  
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-2">{t('cookies.title')}</h1>
          <p className="text-lg text-muted-foreground mb-6">{t('cookies.subtitle')}</p>
          <p className="text-sm text-muted-foreground mb-8">{t('cookies.last_updated')} {formattedDate}</p>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-4">{t('cookies.introduction.title')}</h2>
              <p className="text-muted-foreground">{t('cookies.introduction.content')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">1. What Are Cookies</h2>
              <p className="text-muted-foreground">
                Cookies are small text files that are placed on your computer or mobile device when you visit a 
                website. They are widely used to make websites work more efficiently and provide information to 
                the website owners.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">2. Types of Cookies We Use</h2>
              <p className="text-muted-foreground">
                We use essential cookies that enable core functionality such as security and user preferences. 
                We also use analytics cookies to help us understand how visitors interact with our website, 
                and marketing cookies to deliver targeted advertisements.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">3. How to Manage Cookies</h2>
              <p className="text-muted-foreground">
                Most web browsers allow you to control cookies through their settings preferences. However, 
                limiting the ability of websites to set cookies may impact your user experience. You can also 
                use third-party tools to manage your cookie preferences.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">4. Changes to Our Cookie Policy</h2>
              <p className="text-muted-foreground">
                We may update our Cookie Policy from time to time. Any changes will be posted on this page with 
                an updated revision date. We encourage you to review this policy periodically for any changes.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Cookies;
